import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { GrOrderedList } from "react-icons/gr";
import { FileText, Globe, ShoppingCart } from "lucide-react";
import { useTranslation } from "react-i18next";

import Visibility from "./utils/Visibility";
import { CalcQuantity } from "./utils/CartFunctions";
import { Sheet, SheetTrigger } from "./ui/sheet";
import LangSelect from "./langSelect/langSelect";
import Details from "./Details/Details";
import { indexStore } from "../store/indexStore";
import BranchModel from "../Models/BranchModel";
import { SettingsSocialMedia } from "../Models/SettingsModel";

const NavBottom = (props: any) => {
  const { t } = useTranslation();
  const { lang, changeLangBottomSheet, branch, socialMedia } = indexStore();
  const params = useParams();

  const [quantity, setQuantity] = useState(0);

  // تحديث العدد عند تغيير branch_id أو عند إشعار "cart-updated"
  useEffect(() => {
    const branchId = params?.branch_id ? Number(params.branch_id) : null;
    if (!branchId) return;

    const updateQuantity = () => setQuantity(CalcQuantity(branchId));

    // التحديث المبدئي
    updateQuantity();

    // الاستماع لتغيرات السلة
    window.addEventListener("cart-updated", updateQuantity);

    // تنظيف الحدث عند الإزالة
    return () => {
      window.removeEventListener("cart-updated", updateQuantity);
    };
  }, [params.branch_id]);

  // جلب بيانات الطلبات النشطة من localStorage
  const branchId = params.branch_id ?? "";


  const gridClassName = `grid ${!branchId ? "grid-cols-2" : "grid-cols-3"
    } items-center gap-1`;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-background flex flex-col z-50">
      <nav className={gridClassName}>
        {/* 🌐 اللغة */}
        <Sheet>
          <SheetTrigger asChild>
            <button
              className="flex flex-col gap-1.5 items-center justify-center py-3 px-2 cursor-pointer hover:bg-muted active:bg-muted/80 transition-colors"
              onClick={() => changeLangBottomSheet(true)}
            >
              <div className="p-2 rounded-lg bg-primary/10">
                <Globe className="w-5 h-5 text-primary" />
              </div>
              <span className="text-xs font-semibold text-foreground">
                {lang === "ar" ? "ع" : "EN"}
              </span>
            </button>
          </SheetTrigger>
          <LangSelect />
        </Sheet>

        {/* ℹ️ المعلومات */}
        <Sheet>
          <SheetTrigger asChild>
            <button className="flex flex-col gap-1.5 items-center justify-center py-3 px-2 cursor-pointer hover:bg-muted active:bg-muted/80 transition-colors">
              <div className="p-2 rounded-lg bg-primary/10">
                <FileText className="w-5 h-5 text-primary" />
              </div>
              <span className="text-xs font-semibold text-foreground">
                {t("gloabl.info")}
              </span>
            </button>
          </SheetTrigger>
          <Details branch={branch as BranchModel} social={socialMedia as SettingsSocialMedia[]} />
        </Sheet>

        {/* 🛒 السلة */}
        <Visibility visible={Boolean(branchId)}>
          <Link
            to={`/branches/${branchId}/cart`}
            className="flex flex-col gap-1.5 items-center justify-center py-3 px-2 cursor-pointer hover:bg-muted active:bg-muted/80 transition-colors relative"
          >
            <div className="relative">
              <div className="p-2 rounded-lg bg-primary/10">
                <ShoppingCart className="w-5 h-5 text-primary" />
              </div>
              <Visibility visible={quantity > 0}>
                <span className="absolute -top-1 -right-1 min-w-[20px] h-5 flex items-center justify-center text-xs font-bold bg-primary text-onPrimary px-1.5 rounded-full border-2 border-background">
                  {quantity > 99 ? "99+" : quantity}
                </span>
              </Visibility>
            </div>
            <span className="text-xs font-semibold text-foreground">
              {t("gloabl.Cart")}
            </span>
          </Link>

          {/* 📋 الطلبات */}
          {/* <Visibility visible={Boolean(branchId)}>
            <Link
              to={`/branches/${branchId}/orders`}
              className="flex flex-col gap-1.5 items-center justify-center py-3 px-2 cursor-pointer hover:bg-muted active:bg-muted/80 transition-colors"
            >
              <div className="p-2 rounded-lg bg-primary/10">
                <GrOrderedList className="w-5 h-5 text-primary" />
              </div>
              <span className="text-xs font-semibold text-foreground">
                {t("gloabl.orders")}
              </span>
            </Link>
          </Visibility> */}
        </Visibility>
      </nav>

 
    </div >
  );
};

export default NavBottom;
